var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBackBlack = function SvgIconBackBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M3.469 7.238a.72.72 0 0 1 .72-.72h8.376c2.52 0 4.53 2.1 4.53 4.644s-2.01 4.645-4.53 4.645H6.478a.72.72 0 1 1 0-1.44h6.087c1.685 0 3.09-1.416 3.09-3.205s-1.405-3.204-3.09-3.204H4.189a.72.72 0 0 1-.72-.72",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.445 4.683A.72.72 0 0 1 6.46 5.7l-1.457 1.5 1.459 1.512a.72.72 0 0 1-1.036 1L3.483 7.7a.72.72 0 0 1 .002-1.002l1.942-2a.72.72 0 0 1 1.018-.015",
    clipRule: "evenodd"
  })));
};
export default SvgIconBackBlack;